var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.height < 100)?_c('div',{ref:"container",staticClass:"bg-back-light w-4 h-full ml-1 relative",on:{"click":_vm.jump}},[_c('div',{ref:"scrollbar",staticClass:"w-4 absolute bg-back-dark opacity-50 cursor-pointer",style:({
      height: (_vm.height + "%"),
      top: (_vm.scrolling + "%"),
    }),on:{"touchstart":_vm.startDrag,"mousedown":_vm.startDrag}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }